import { useSignalEffect } from '@preact/signals';
import { useQuery } from './useQuery';
import {
  fetchNotifications,
  notifications,
  NOTIFICATIONS_QUERY_KEY,
  NOTIFICATIONS_POLL_INTERVAL,
  type NotificationItem,
} from '@/stores/notifications';

/**
 * Fetches notifications via `useQuery` with automatic polling.
 *
 * Syncs fetched data into the `notifications` signal from the store so that
 * `unreadCount` (computed) and optimistic mutations (`markRead`, `markAllRead`)
 * continue to work reactively across the app.
 *
 * Mount this hook in a component that lives as long as the user is
 * authenticated (e.g. `NotificationCenter` inside `TopBar`).
 */
export function useNotifications() {
  const query = useQuery<NotificationItem[]>(NOTIFICATIONS_QUERY_KEY, fetchNotifications, {
    refetchInterval: NOTIFICATIONS_POLL_INTERVAL,
  });

  // Sync query cache data into the store signal so unreadCount (computed) and
  // optimistic mutations (markRead/markAllRead) stay reactive.
  useSignalEffect(() => {
    const items = query.data.value;
    if (items) {
      notifications.value = items;
    }
  });

  return query;
}
